import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';

import {
  EMPTY_SIMS_FETCH,
  FREE_NUMBERS_FETCH,
  FREE_NUMBERS_RECEIVE,
  EMPTY_SIMS_RECEIVE,
  NEW_SUBSCRIPTION_FINISHED,
  ABLE_TO_ACTIVATE_FETCH,
  ABLE_TO_ACTIVATE_RECEIVE,
} from './constants'

const initialState = fromJS({
  ready: false,
  fetching: false,
  emptySims: null,
  freeNumbers: null,
  error: null,
  newSubFinished: false,
  switchSimCardFinished: false,
  ableToActivate: null,
});

export const reducer = handleActions({
  [EMPTY_SIMS_FETCH]: (state) => (
    state
      .set('fetching', true)
      .set('ready', false)
  ),

  [FREE_NUMBERS_FETCH]: (state) => (
    state
      .set('fetching', true)
      .set('ready', false)
  ),
  [FREE_NUMBERS_RECEIVE]: (state, action) => (
    state
      .set('fetching', false)
      .set('ready', true)
      .set('freeNumbers', fromJS(action.payload.freeNumbers))
  ),

  [EMPTY_SIMS_RECEIVE]: (state, action) => (
    state
      .set('fetching', false)
      .set('ready', true)
      .set('emptySims', fromJS(action.payload.emptySims))
  ),

  [NEW_SUBSCRIPTION_FINISHED]: (state) => (
    state
      .set('newSubFinished', true)
  ),

  [ABLE_TO_ACTIVATE_FETCH]: (state) => (
    state
      .set('fetching', true)
      .set('ready', false)
      .set('ableToActivate', null)
  ),
  [ABLE_TO_ACTIVATE_RECEIVE]: (state, action) => (
    state
      .set('fetching', false)
      .set('ready', true)
      .set('ableToActivate', fromJS(action.payload.ableToActivate))
  ),
}, initialState);

export default reducer
